import { useMarketManagers } from 'typescript/context/market_managers';

// These are just some standard props you can configure on the market toast
// if more things need to be added like inline links or buttons, we can add them here as potential props
// https://market-storybook.s3.amazonaws.com/7.0.0/index.html?path=/docs/components-toast-toaster-toast-api--docs
type Toast = {
  message?: string;
  persistent?: HTMLMarketToastElement['persistent'];
  variant?: HTMLMarketToastElement['variant'];
};

/**
 * Hook to help display a Market Toast
 * @returns a function `showToast` which can be called to show a market-toast
 * @example
 * const { showToast } = useToaster();
 * showToast({ message: 'Hello World!', persistent: false, variant: 'success' });
 * showToast({ message: 'Wow!', variant: 'error' });
 */
export const useToaster = () => {
  const { toasterRef } = useMarketManagers();

  const showToast = ({
    message = '',
    persistent = false,
    variant = 'info',
  }: Toast) => {
    if (!toasterRef.current) {
      return;
    }

    const newToast = document.createElement('market-toast');
    newToast.variant = variant;
    newToast.textContent = message;
    newToast.persistent = persistent;

    toasterRef.current.show(newToast);
  };

  return { showToast };
};
